import * as Page from '@avcan/prismic/clients/page'
import { Page as Layout } from 'layouts/pages'
import { Static } from 'prismic/layouts'
import * as NextUtils from 'utils/next'

export async function getStaticProps({ locale, params }) {
    const { number } = params
    const id = 'spring-conditions-scenario' + number

    return {
        props: {
            document: await Page.get(id, locale),
        },
    }
}

export function getStaticPaths() {
    const paths = [1, 2, 3, 4].map(number => ({
        params: {
            number: String(number),
        },
    }))

    return {
        paths: NextUtils.internationalizeStaticPaths(paths),
        fallback: false,
    }
}

export default function SpringConditionsScenario1({ document }) {
    return (
        <Layout>
            <Static document={document} />
        </Layout>
    )
}
